<template>
  <div class="org-summary-container">
    <div class="org-summary">
      <div class="org-summary__column">
        <dep-name class="visible-xs-block"
                  :org="org"
                  :perms="perms"></dep-name>
        <contacts :contacts="org.getContacts()" :address="org.getAddress()"></contacts>
        <system-info :org="org"></system-info>
        <qrcode></qrcode>
      </div>
      <div class="org-summary__column">
        <dep-name class="hidden-xs"
                  :org="org"
                  :perms="perms"></dep-name>
        <description :description="org.getDescription()"></description>
        <structure class="org-summary__item" :orgId="org.getId()"></structure>
        <staff class="org-summary__item" :orgId="org.getId()"></staff>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import fullMap from './fullMap.vue'
  import editDep from './edit.vue';
  import depName from './name.vue';
  import contacts from './contacts.vue';
  import systemInfo from './systemInfo.vue';
  import description from './description.vue';
  import structure from './structure.vue';
  import staff from './staff.vue';
  import qrcode from './qrcode.vue';

  export default {
    props: ['org'],
    components: {
      fullMap,
      editDep,
      depName,
      contacts,
      systemInfo,
      qrcode,
      description,
      structure,
      staff,
    },
    computed: {
      perms: self => {
        return {
          update: true
        }
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';
.org-summary {
  display: grid;
  grid-template-columns: 250px 1fr;
  grid-column-gap: 30px;

  @media (max-width: $screen-sm){
     grid-template-columns: 1fr;
  }

  &__column {
    min-width: 0;
  }

  &__item {
    overflow-x: auto;
  }
}
</style>